export const showAtcModal = (modalElement, backdropElement) => {
  modalElement.classList.add('wrapper-visible');
  modalElement.setAttribute('aria-hidden', false);
  backdropElement.classList.add('active');
  document.documentElement.classList.add('overflow-hidden');
  document.body.classList.add('overflow-hidden');
};